export default {
  watch: {
    id(val) { if(!val) return; this.register(this.draw); },
    Canvas: { handler(val) { if(!val || Object.keys(val).length === 0 || this.modeService) return; this.register(this.draw); }, deep: true },
    DataItems: { handler(val) { if(!val || val.length === 0 || this.modeService) return; this.register(this.draw); }, deep: true },
  },
}
